<template>
  <q-carousel
    v-model="currentSlide"
    :swipeable="swipeable"
    :animated="animated"
    :control-color="controlColor"
    :navigation-icon="navigationIcon"
    :navigation-active-icon="navigationActiveIcon"
    :navigation="navigation"
    :arrows="arrows"
    :infinite="infinite"
    :autoplay="autoplay"
    :height="height" >
    <slot/>
  </q-carousel>
</template>

<script>
export default {
  name: 'RCarousel',
  props: {
    navigation: Boolean,
    navigationIcon: String,
    navigationActiveIcon: String,
    arrows: Boolean,
    controlColor: String,
    backgroundColor: String,
    textColor: String,
    animated: Boolean,
    swipeable: Boolean,
    autoplay: [Number, Boolean],
    infinite: Boolean,
    height: String,
  },
  data() {
    return {
      currentSlide: 1,
    };
  },

};
</script>
